module.exports = __webpack_public_path__ + "static/media/mano_animada.00b5325d.gif";